<div class="row" *ngIf="user">
    <div class="col">
        <div class="form-group form-inline">
            <input class="form-control" type="text" [formControl]="searchTermControl" placeholder="Rechercher" />
            <select class="form-control ml-2" [formControl]="sessionFilterControl">
                <option value="all" default>Toutes les sessions</option>
                <option *ngFor="let session of sessions" [value]="session.id">
                    {{session.code}}
                </option>
            </select>
            <small class="ml-2">
                Total: {{itemsCount}}
            </small>
        </div>
    </div>
    <div class="col">
        <ngb-pagination (pageChange)="onPageChange($event)" [page]="page" [pageSize]="pageSize"
            [collectionSize]="itemsCount"></ngb-pagination>
    </div>

    <div *ngIf="user.isStaff || user.isExamCenterBoss" class="col d-flex justify-content-end">
        <button class="btn btn-link" (click)="add()">
            <i class="fas fa-plus"></i>
            Ajouter une nouvelle pré-inscription
        </button>
        <button class="btn btn-link" (click)="openImportModal()">
            <i class="fas fa-upload"></i>
            Importer des pré-inscriptions
        </button>
    </div>
</div>

<div class="row mb-2" *ngIf="user">
    <div class="col">
        <div class="d-flex flex-wrap" style="gap: 0.5rem;" role="group">
            <button type="button" class="btn btn-sm rounded-pill" style="white-space: nowrap;"
                [class.btn-primary]="statusFilterControl.value === 'all'"
                [class.btn-outline-secondary]="statusFilterControl.value !== 'all'"
                (click)="setStatusFilter('all')">
                Toutes ({{ statusCounts.total }})
            </button>
            <button type="button" class="btn btn-sm rounded-pill" style="white-space: nowrap;"
                [class.btn-warning]="statusFilterControl.value === 'waiting'"
                [class.btn-outline-secondary]="statusFilterControl.value !== 'waiting'"
                (click)="setStatusFilter('waiting')">
                En attente ({{ statusCounts.waiting }})
            </button>
            <button type="button" class="btn btn-sm rounded-pill" style="white-space: nowrap;"
                [class.btn-info]="statusFilterControl.value === 'to_send'"
                [class.btn-outline-secondary]="statusFilterControl.value !== 'to_send'"
                (click)="setStatusFilter('to_send')">
                A envoyer ({{ statusCounts.to_send }})
            </button>
            <button type="button" class="btn btn-sm rounded-pill" style="white-space: nowrap;"
                [class.btn-danger]="statusFilterControl.value === 'to_follow_up'"
                [class.btn-outline-secondary]="statusFilterControl.value !== 'to_follow_up'"
                (click)="setStatusFilter('to_follow_up')">
                A relancer ({{ statusCounts.to_follow_up }})
            </button>
            <button type="button" class="btn btn-sm rounded-pill" style="white-space: nowrap;"
                [class.btn-success]="statusFilterControl.value === 'confirmed'"
                [class.btn-outline-secondary]="statusFilterControl.value !== 'confirmed'"
                (click)="setStatusFilter('confirmed')">
                Confirmées ({{ statusCounts.confirmed }})
            </button>
            <button type="button" class="btn btn-sm rounded-pill" style="white-space: nowrap;"
                [class.btn-secondary]="statusFilterControl.value === 'expired'"
                [class.btn-outline-secondary]="statusFilterControl.value !== 'expired'"
                (click)="setStatusFilter('expired')">
                Expirées ({{ statusCounts.expired }})
            </button>
        </div>
    </div>
</div>

<app-loading-overlay [active]="loading">
    <table class="table table-striped" *ngIf="user">
        <thead>
            <tr>
                <ng-container>
                    <th scope="col">
                        Candidat
                    </th>

                    <th scope="col">
                        Session
                    </th>

                    <th scope="col">
                        Statut
                    </th>

                    <th scope="col">
                        Ticket
                    </th>

                    <th scope="col">
                        Dossier CPF
                    </th>

                    <th *ngIf="user.isStaff" scope="col">
                        Création
                    </th>

                    <th scope="col">
                        Convocations
                    </th>

                    <th scope="col" class="text-center">
                        Confirmation
                    </th>

                    <th scope="col" *ngIf="user.isStaff || user.isExamCenterBoss">Actions</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let preregistration of preregistrations; index as i">
                <td>
                    <i *ngIf="preregistration.psh" class="fas fa-wheelchair" style="margin-right: 5px;"></i>
                    <ngb-highlight [result]="preregistration.firstname" [term]="searchTermControl.value"
                        style="margin-right: 5px;">
                    </ngb-highlight>

                    <ngb-highlight [result]="preregistration.lastname" [term]="searchTermControl.value">
                    </ngb-highlight>

                    <br>

                    <ngb-highlight [result]="preregistration.email" [term]="searchTermControl.value">
                    </ngb-highlight>

                    <br>

                    <ngb-highlight [result]="preregistration.phoneNumber" [term]="searchTermControl.value">
                    </ngb-highlight>
                </td>

                <td>
                    <ngb-highlight [result]="preregistration.session.code" [term]="searchTermControl.value">
                    </ngb-highlight>
                </td>

                <td>
                    <span class="badge" [ngClass]="preregistration.session.displayStatusClass">{{ preregistration.session.displayStatus }}</span>
                </td>

                <td>
                    <ngb-highlight *ngIf="preregistration.exam" [result]="preregistration.exam.voucher_code"
                        [term]="searchTermControl.value">
                    </ngb-highlight>
                    <ng-container *ngIf="!preregistration.exam">
                        <span *ngIf="user.isStaff || user.isExamCenterBoss" class="btn-assign text-secondary "
                            (click)="openSelectExamModal(preregistration)">
                            En attente d'attribution
                        </span>
                        <span *ngIf="!user.isStaff && !user.isExamCenterBoss" class="text-secondary">
                            En attente d'attribution
                        </span>
                    </ng-container>
                </td>

                <td>
                    <ngb-highlight [result]="preregistration.fileNumber" [term]="searchTermControl.value">
                    </ngb-highlight>
                </td>

                <td *ngIf="user.isStaff">
                    Le {{ preregistration.createdDate | date: 'dd/MM/yyyy' }}<br>
                    Par {{ preregistration.author.fullName }}
                </td>

                <td>
                    <div *ngFor="let convocation of preregistration.convocations" class="mb-1" style="white-space: nowrap;">
                        <ng-template #convocationTooltip>
                            <div>- Nom : {{ convocation.firstname }} {{ convocation.lastname }}</div>
                            <div>- Session : {{ convocation.sessionCode }}</div>
                            <div>- Voucher : {{ convocation.voucherCode }}</div>
                            <div>- Tracking mail : {{ convocation.emailStatusDisplay.label }}</div>
                        </ng-template>
                        <span class="badge badge-secondary mr-2" [ngbTooltip]="convocationTooltip" tooltipClass="convocation-tooltip" container="body">{{ convocation.convocationSentAt | date: 'dd/MM/yyyy' }}</span>
                        <span [ngClass]="convocation.emailStatusDisplay.textClass"
                            [title]="convocation.emailStatusDisplay.title"><i class="fas mr-1" [ngClass]="convocation.emailStatusDisplay.iconClass" aria-hidden="true"></i>{{ convocation.emailStatusDisplay.label }}</span>
                    </div>

                    <div *ngIf="preregistration.exam == null" class="alert alert-warning small py-1 px-2 mb-0" role="alert">
                        Attribuez un ticket
                    </div>

                    <div *ngIf="preregistration.exam != null && preregistration.exam.certification == null"
                        class="alert alert-warning small py-1 px-2 mb-0" role="alert">
                        Attribuez une certification au ticket
                    </div>

                    <p *ngIf="preregistration.ticketUsedAt() != null" class="text-muted" style="margin-bottom: 0;">
                        Le ticket a déjà été consommé le {{ preregistration.ticketUsedAt() | date: 'dd/MM/yyyy' }}
                    </p>
                </td>

                <td class="text-center">
                    <span *ngIf="preregistration.studentConfirmedAt() != null" class="badge badge-success">{{ preregistration.studentConfirmedAt() | date: 'dd/MM/yyyy' }}</span>
                </td>

                <td *ngIf="user.isStaff || user.isExamCenterBoss">
                    <ng-container
                        *ngIf="preregistration.ticketUsedAt() == null && preregistration.studentConfirmedAt() == null">
                        <button class="btn btn-link" (click)="edit(preregistration)">
                            <i class="fas fa-edit" style="margin-right: 4px;"></i>Modifier
                        </button>
                        <br>
                        <button class="btn btn-link" style="color: red;" (click)="remove(preregistration)">
                            <i class="fas fa-trash" style="margin-right: 4px;"></i>Supprimer
                        </button>
                        <br>
                    </ng-container>

                    <button class="btn btn-link" (click)="sendConvocation(preregistration)"
                        *ngIf="preregistration.exam != null && preregistration.exam.certification && preregistration.studentConfirmedAt() == null && preregistration.ticketUsedAt() == null"
                        [disabled]="preregistration.convocationIsSending || preregistration.convocationBlockedReason != null"
                        [title]="preregistration.convocationBlockedReason || ''">
                        <i class="fas fa-paper-plane" style="margin-right: 4px;"></i>
                        <span *ngIf="preregistration.convocationIsSending" class="button-loader"></span>
                        <span *ngIf="!preregistration.convocationIsSending">
                            <span *ngIf="preregistration.hasCurrentConvocation">Relancer</span>
                            <span *ngIf="!preregistration.hasCurrentConvocation">Envoyer</span>
                        </span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</app-loading-overlay>
